"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextBase = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.TextBase = (0, styled_components_1.default)('span') `
  color: var(--Text, #333);
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
`;
